
import { notify } from "@kyvg/vue3-notification";

export const capitalize = (s) => s && s.length > 0 && s[0].toUpperCase() + s.slice(1);

export const getMesesLista = (localizacao, tipo) =>
  Array.from(Array(12).keys(), (i) =>
    capitalize(new Intl.DateTimeFormat(localizacao, {
      month: tipo || 'long',
    }).format(new Date(0, i))),
  );

export const getDiasdaSemana = (localizacao, tipo, date) =>
  Array.from(Array(7).keys(), (i) =>
    new Intl.DateTimeFormat(localizacao, {
      weekday: tipo || 'long',
    }).format(new Date(0, 0, date ? i : i + 1)),
  );

// Função para formatar valor em reais (BRL)
export const moneyMaskBrl = money => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(money);
};

// Função para remover a formatação de moeda
export const removeMoneyMaskBrl = valor => {
  return valor.replace(/[^\d,]/g, '').replace(',', '.');
};

// Função para formatar input em formato de dinheiro com máscara de reais (BRL) ao digitar
export const keyUpFormatInputMoneyMaskBrl = money => {
  let numericValue = money.replace(/\D/g, "");
  const integerPart = numericValue.slice(0, -2) || "0";
  const decimalPart = numericValue.slice(-2) || "00";

  const formattedIntegerPart = parseInt(integerPart, 10).toLocaleString('pt-BR');
  return `R$ ${formattedIntegerPart},${decimalPart}`;
};

export const numeroParaReal = (numero) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numero);
};

export const notifyAlertErrorGeneral = (grupo) => {
  notify({
    group: grupo,
    duration: 5000,
    type: 'error',
    title: 'Sem conexão com o servidor',
    text: 'Desculpe os transtornos.',
  });
};

export const notifyAlert = (titulo, texto, tipo = '') => {
  notify({
    type: tipo,
    title: titulo,
    text: texto,
    duration: 5000,
  });
};

/**
 * Métodos para tratamento nas chamadas do service
 */
// Verifica se foi retornados dados da resposta
export const noRecordsFoundResponseService = (response) => {
  const records = response?.data?.data ?? false;
  return !records || typeof records !== 'object' || Object.keys(records).length === 0;
};

// Verifica se a resposta de erro contem dados
export const isValidErrorDataResponseService = (error) => {
  return !!((error && error.response && error.response.data));
};

// Verifica se a resposta de erro contem mensagem
export const isValidErrorMessageResponseService = (response) => {
  const message = response?.response?.data?.message ?? false;
  return (message && message !== 'undefined' && message.length > 0) ? message : false;
};

// Verifica se a resposta de erro contem o status code
export const isValidErrorStatusCodeResponseService = (error) => {
  const statuscode = (error?.response?.data?.statuscode) ?? ((error?.response?.status) ?? false);
  if (statuscode !== false && statuscode !== 'undefined') {
    return statuscode;
  }
  return false;
};

/**
 * Tratamento das mensagens de erro retornadas da chamada ao backend pelo service para casos de erro na conexão
 */
export const notifyAlertErrorResponseService = (errorResponse, serviceName = 'de conexão com a API', messageHandler = false) => {
  let tipo = '';
  let titulo = '';
  let texto = '';
  const errorData = isValidErrorDataResponseService(errorResponse);
  const errorMessage = isValidErrorMessageResponseService(errorResponse);
  const errorStatuscode = isValidErrorStatusCodeResponseService(errorResponse);
  if (errorData && errorMessage && errorStatuscode) {
    switch (errorStatuscode) {
      case 404:
        tipo = 'info';
        titulo = 'Aviso: Consulta efetuada';
        texto = `Nenhum registro foi encontrado para a consulta no serviço "${serviceName}".`;
        break;
      case 422: {
        tipo = 'warn';
        titulo = `Parâmetros inválidos no serviço "${serviceName}"`;
        const nestedErrors = errorResponse?.response?.data?.data?.errors;
        if (nestedErrors && typeof nestedErrors === 'object' && Object.keys(nestedErrors).length > 0) {
          texto = Object.values(nestedErrors).join('<br/>');
        } else {
          texto = (errorMessage !== null && typeof errorMessage === 'object' && Object.keys(errorMessage).length > 1 ? Object.values(errorMessage).join("<br/>") : `${errorMessage}`);
        }
        break;
      }
      case 500:
        tipo = 'error';
        titulo = 'Erro Interno do Servidor';
        texto = `Lamentamos o transtorno, o serviço "${serviceName}" encontra-se temporariamente indisponível.`;
        break;
      case 503:
        tipo = 'error';
        titulo = 'Serviço Indisponível';
        texto = `O serviço "${serviceName}" encontra-se temporariamente indisponível. Por favor, tente novamente mais tarde.`;
        break;
      default:
        tipo = 'error';
        titulo = 'Lamentamos o transtorno';
        texto = `Ocorreu um erro inesperado ao acessar o serviço "${serviceName}".`;
        break;
    }
  } else {
    tipo = 'error';
    titulo = `Desculpe, um erro ocorreu ao buscar os dados "${serviceName}".`;
    texto = `A conexão com a API encontra-se indisponível no momento.`;
  }

  if (messageHandler != false) {
    tipo = (messageHandler?.tipo ?? tipo);
    titulo = (messageHandler?.titulo ?? titulo);
    texto = (messageHandler?.texto ?? texto);
  }
  notify({
    type: tipo,
    title: titulo,
    text: texto,
    position: 'bottom right',
    duration: 5000,
  });
};

export const notifyAlertNoRecordsFoundResponseService = (serviceName = '') => {
  const serviceNameText = (serviceName !== '' ? ` na consulta ao serviço ${serviceName}.` : '.');
  notify({
    type: 'success',
    title: 'Consulta realizada',
    text: `Não foram encontrados registros${serviceNameText}`,
    position: 'bottom right',
    duration: 5000,
  });
};

// export const notifyAlertCRUDResponseService = (action = false, ) => {
// };

export const notifyAlertCreateRecordSuccessResponseService = (serviceName = '') => {
  const serviceNameText = (serviceName !== '' ? `${serviceName} ` : 'Registro ');
  notify({
    type: 'success',
    title: 'Sucesso',
    text: `${serviceNameText}salvo com sucesso!`,
    position: 'bottom right',
    duration: 5000,
  });
};

export const notifyAlertSaveSuccess = () => {
  notify({
    type: 'success',
    title: 'Sucesso',
    text: 'Registro Salvo com Sucesso!',
    position: 'bottom right',
    duration: 5000,
  });
};

export const notifyAlertUpdateRecordSuccessResponseService = (serviceName = '') => {
  const serviceNameText = (serviceName !== '' ? `Registro ${serviceName} ` : 'Registro ');
  notify({
    type: 'success',
    title: 'Sucesso',
    text: `${serviceNameText}alterado com sucesso.`,
    position: 'bottom right',
    duration: 5000,
  });
};

export const notifyAlertAlterStatusSuccessResponseService = (serviceName = '', customMessage = '') => {
  const serviceNameText = (serviceName !== '' ? ` do(a) ${serviceName} ` : ' ');
  const trimmed = typeof customMessage === 'string' ? customMessage.trim() : '';
  const text = trimmed.length > 0
    ? trimmed
    : `Status${serviceNameText}alterado(a) com sucesso.`;
  notify({
    type: 'success',
    title: 'Sucesso',
    text,
    position: 'bottom right',
    duration: 5000,
  });
};

export const notifyAlertDeleteRecordSuccessResponseService = (serviceName = '') => {
  const serviceNameText = (serviceName !== '' ? ` do serviço ${serviceName} ` : ' ');
  notify({
    type: 'success',
    title: 'Sucesso',
    text: `Registro${serviceNameText}excluído com sucesso.`,
    position: 'bottom right',
    duration: 5000,
  });
};

export const maskFormatedPhoneNumber = (num) => {
    if (num.startsWith('0800')) {
      num = num.slice(0, 11);
      num = num.replace(/^(\d{4})(\d{3})(\d{4})/, '0800.$2.$3');
    } else {
      num = num.slice(0, 11);

      if (num.length <= 10) {
        num = num.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else {
        num = num.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
    }
    return num;
};